import { render } from "./BlogDetails.vue?vue&type=template&id=1ba32765&ts=true"
import script from "./BlogDetails.vue?vue&type=script&lang=ts"
export * from "./BlogDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__